export const externalUrls = {
  // eslint-disable-next-line @stylistic/max-len
  mfaFaq: 'https://paymentshelp.triumph.io/support/solutions/articles/44002622497-how-to-set-up-multi-factor-authentication-mfa-',
  privacyPolicy: 'https://www.triumph.io/privacy-policy/',
  smsTermsOfService: 'https://triumph.io/sms-terms/',
  termsOfService: 'https://triumph.io/terms-of-service/',
};
